import {
	influencerByID,
	influencerCreate,
	influencerDestroy,
	influencerUpdate,
	influencersList,
} from '@/services/agency/showcaseInfluencers.service'

export default {
	namespaced: true,
	state: {
		// SHOWCASES INFLUENCERS
		influencersList: {
			data: [],
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		influencer: {},
		// STATUS SHOWCASES INFLUENCERS
		influencersStatus: 'pending',
		influencersSaveStatus: 'init',
		influencersDeleteStatus: 'init',
	},
	getters: {
		// SHOWCASES INFLUENCERS
		getInfluencersList(state) {
			return state.influencersList
		},
		getInfluencer(state) {
			return state.influencer
		},
		// SHOWCASES INFLUENCERS
		getInfluencersDeleteStatus(state) {
			return state.influencersDeleteStatus
		},
		getInfluencersSaveStatus(state) {
			return state.influencersSaveStatus
		},
		getInfluencersStatus(state) {
			return state.influencersStatus
		},
	},
	mutations: {
		// SHOWCASES INFLUENCERS
		INFLUENCERS_LIST(state, value) {
			state.influencersList = value
		},
		SET_INFLUENCER(state, value) {
			state.influencer = value
		},
		// STATUS SHOWCASES INFLUENCERS
		INFLUENCERS_STATUS(state, value) {
			state.influencersStatus = value
		},
		INFLUENCER_SAVE_STATUS(state, value) {
			state.influencersSaveStatus = value
		},
		INFLUENCER_DELETE_STATUS(state, value) {
			state.influencersDeleteStatus = value
		},
	},
	actions: {
		// SHOWCASES Influencers
		async fetchInfluencerList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('INFLUENCERS_STATUS', 'pending')
			commit('INFLUENCERS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const merged = { per_page: 'all', ...params }
				const { data } = await influencersList(merged)
				commit('INFLUENCERS_STATUS', 'init')
				commit('INFLUENCERS_LIST', data)
				return data
			} catch (error) {
				commit('INFLUENCERS_STATUS', 'init')
				throw error
			}
		},
		async fetchInfluencerByID({ commit }, params) {
			commit('INFLUENCERS_STATUS', 'pending')
			try {
				const { data } = await influencerByID(params)
				commit('INFLUENCERS_STATUS', 'init')
				commit('SET_INFLUENCER', data.data)
				return data
			} catch (error) {
				commit('INFLUENCERS_STATUS', 'init')

				return error
			}
		},
		async saveNewInfluencer({ commit }, params) {
			commit('INFLUENCER_SAVE_STATUS', 'pending')
			try {
				const { data } = await influencerCreate(params)
				commit('INFLUENCER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INFLUENCER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateInfluencer({ commit }, params) {
			commit('INFLUENCER_SAVE_STATUS', 'pending')
			try {
				const { data } = await influencerUpdate(params)
				commit('INFLUENCER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INFLUENCER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteInfluencerByID({ commit }, params) {
			commit('INFLUENCER_DELETE_STATUS', 'pending')
			try {
				const { data } = await influencerDestroy(params)
				commit('INFLUENCER_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INFLUENCER_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
